import { render, staticRenderFns } from "./ReportMealsTabTakenMeals.vue?vue&type=template&id=bc653c88&scoped=true"
import script from "./ReportMealsTabTakenMeals.vue?vue&type=script&lang=js"
export * from "./ReportMealsTabTakenMeals.vue?vue&type=script&lang=js"
import style0 from "./ReportMealsTabTakenMeals.vue?vue&type=style&index=0&id=bc653c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc653c88",
  null
  
)

export default component.exports